import { Injectable } from '@angular/core';
import { IAppConfig } from './app-config';

@Injectable()
export class AppConfig {
    static settings: IAppConfig;
    constructor() {}
    load() {
        const appConfFile = `assets/config.json`;
        return new Promise<void>((resolve, reject) => {
            fetch(appConfFile).then(response => {
                if (!response.ok) {
                    throw new Error(`Could not load file '${appConfFile}': ${response.statusText}`);
                }
                return response.json();
            }).then((response: IAppConfig) => {
                AppConfig.settings = response;
                resolve();
            }).catch((error) => {
                reject(error.message);
            });
        });
    }
}